import { Box, Stack } from "@mui/material"
import { UiCtButton } from "../../../../MuiStyled/LibComponent"

function AddRowOverlay({ handleAddRow = null, emptyLabel = "No rows yet" }) {
  // Compact, left-aligned empty state: the quiet "No … yet" label and the Add
  // affordance sit flush to the content column rather than floating centered,
  // so the section reads tight with no awkward whitespace band.
  return (
    <Box className="newgame-empty-state" sx={{ minHeight: "auto", width: "100%", padding: "4px 0" }}>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"flex-start"} spacing={2} sx={{ width: "100%" }}>
        <div className="newgame-empty-label">{emptyLabel}</div>
        {handleAddRow != null ? (
          <UiCtButton variant="outlined" startIcon={<i className={`fa-solid fa-add`}></i>} onClick={handleAddRow}>
            Add
          </UiCtButton>
        ) : (
          <></>
        )}
      </Stack>
    </Box>
  )
}

export default AddRowOverlay
